import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { reviewTags, reviews } from '@/mocks/home';

export default function ReviewsSection() {
  const [activeTag, setActiveTag] = useState<string>(reviewTags[0]);
  const visible =
    activeTag === '全部' ? reviews : reviews.filter((item) => item.tag === activeTag);

  return (
    <section id="reviews" className="bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-6xl">
        <SectionHeading
          eyebrow="观后感"
          title="剧迷都在聊什么"
          desc="整理自公开讨论区的典型观点，按口碑标签筛选，看看大家关注的点都在哪里。"
        />

        <div className="reveal mt-6 flex flex-wrap gap-2 md:mt-8">
          {reviewTags.map((tag) => {
            const isActive = tag === activeTag;
            return (
              <button
                key={tag}
                type="button"
                onClick={() => setActiveTag(tag)}
                aria-pressed={isActive}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-secondary-500 text-background-50'
                    : 'border border-background-300 bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {tag}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {visible.map((review) => (
            <article
              key={review.name}
              className="reveal flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                  {review.tag}
                </span>
                <span className="flex items-center gap-0.5" aria-label={`评分 ${review.rating} 分，满分 5 分`}>
                  {Array.from({ length: 5 }).map((_, index) => (
                    <i
                      key={index}
                      className={
                        index < review.rating
                          ? 'ri-star-fill text-sm text-accent-500'
                          : 'ri-star-line text-sm text-foreground-300'
                      }
                      aria-hidden="true"
                    ></i>
                  ))}
                </span>
              </div>
              <p className="mt-4 flex-1 text-sm leading-7 text-foreground-700">{review.text}</p>
              <p className="mt-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                {review.name}
              </p>
            </article>
          ))}
        </div>

        {visible.length === 0 ? (
          <p className="mt-8 text-center text-sm text-foreground-500">
            这个标签下暂时还没有整理到观点。
          </p>
        ) : null}
      </div>
    </section>
  );
}